import { render, staticRenderFns } from "./comment-popup.vue?vue&type=template&id=2bfc63b7&scoped=true&"
import script from "./comment-popup.vue?vue&type=script&lang=js&"
export * from "./comment-popup.vue?vue&type=script&lang=js&"
import style0 from "./comment-popup.vue?vue&type=style&index=0&id=2bfc63b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc63b7",
  null
  
)

export default component.exports